import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { typographySelectorMap } from 'src/editor/store/website-settings/website-settings-selector'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateFontWeight = ({
  fontWeight,
  mobileFontWeight,
  typographyType = WebsiteSettingsTypographyTypeEnum.Paragraph,
}: {
  fontWeight?: string
  mobileFontWeight?: string
  typographyType?: WebsiteSettingsTypographyTypeEnum
}) => {
  const pageGlobalFontWeight = usePage(
    pageSelectors.getGlobalFontProperties,
  ).fontWeight

  const typographySelector = typographySelectorMap[typographyType]

  const {
    fontWeight: websiteGlobalFontWeight,
    mobileFontWeight: globalMobileFontWeight,
  } = useWebsiteSettings(typographySelector) || {}

  const globalFontWeight = pageGlobalFontWeight || websiteGlobalFontWeight

  return {
    calculatedFontWeight: getCalculatedProperty({
      desktopProperty: fontWeight,
      mobileProperty: mobileFontWeight,
      globalDesktopProperty: globalFontWeight,
      globalMobileProperty: globalMobileFontWeight,
    }),
    globalFontWeight,
    globalMobileFontWeight: globalMobileFontWeight || globalFontWeight,
  }
}
